import React from "react";
import PropTypes from "prop-types";
import { FormattedMessageAnchor } from "../../commonComponents";
import Modal from '../baseModal'
import configData from "Content/content.json";

const TYPE = "freeTrial";
const envLanguage = process.env.REACT_APP_LOCALE || "en";

const freetrialModalData = {
  title: TYPE,
  content: configData["data"][TYPE][envLanguage]
};
const title = {
  id: "modal.free_trial",
  defaultMessage: "Free Trial"
};
const FreeTrialModal = ({ onClose }) => (
  <Modal onClose={onClose} title={title} modalType="buy">
    <ul className="lists">
      {freetrialModalData.content.map(({ name, url }, index) => (
        <li className="lists--item" data-layer-menu_item="lists--item" key={index}>
          {name}
          <FormattedMessageAnchor
              className="text-uppercase"
              href={url}
              target="_blank"
              id="modal.go"
              defaultMessage="Go"
              className="link"
            />
        </li>
      ))}
    </ul>
  </Modal>
);

FreeTrialModal.propTypes = {
  onClose: PropTypes.func
};

export default FreeTrialModal;
